<div class="logo-container" [ngSwitch]="logoDisplayService.type">
    <img *ngSwitchCase="'branding'" src="./branding.svg"/>
    <img *ngSwitchCase="'whiteLabel'" [src]="logoDisplayService.whiteLabelLogoUrl | safe : 'url'"/>
    <ac-svg *ngSwitchCase="'login'" [name]="logoDisplayService.logoName" class="{{logoDisplayService.logoName}}"></ac-svg>
    <img *ngSwitchCase="'tenant'" [src]="logoDisplayService.tenantLogoUrl"/>
    <ac-svg *ngSwitchCase="'internal'" [name]="logoDisplayService.logoName"></ac-svg>
</div>
